// ═══ v2 화면 플래그 (BRIEF D9 · ADMIN.md S1) ═══
// role 'user'(수출업체) · 관리자(admin/관리자) · 서류대행(doc_agency) 은 언제나 v2. 다른 role(대행업체·관세사·캐리어·쇼링·기사) 은 언제나 v1.
// 2026-09-22 Jin 결정 "v1 은 되돌릴 일이 없다" — `?ui=v1` / localStorage 'autodex_ui' 탈출구 제거.
// (옛 브라우저에 남은 'autodex_ui' 키는 더 이상 읽지 않는다.)
// 서류대행은 V2_DOC_AGENCY_MENUS + 헤더 업체 선택 버튼/모달 (roles-redesign/A-docagency.md A1·A2).
// 운영 관리자(operator, 화면 라벨 '관리자')도 v2 — V2_OPERATOR_MENUS 6항목. 업체 데이터 화면이 하나도 없고
// 라우트 표 자체가 다르지만(Dashboard.js operator 분기), 셸·킷·토큰은 같은 것을 쓴다.
var V2_ROLES = ['user', 'admin', '관리자', 'doc_agency', 'operator'];

export function isV2(user) {
  return !!user && V2_ROLES.indexOf(user.role) >= 0;
}
